import { Button, Input, Select, SelectItem, Textarea } from '@nextui-org/react';
import axios from 'axios';
import React from 'react'
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AddExpense = () => {

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formdata = new FormData(e.target);
        const data = Object.fromEntries(formdata.entries());
        if (!data.amount || !data.date || !data.reason) {
            toast.error("Missing some fields!")
            return;
        }

        try {
            const response = await axios.post("/expenses/createExpense", data);
            if (response.data.success) {
                toast.success(response.data.message);
                navigate('/allExpenses')
            }
        } catch (error) {
            // console.log(error);
            toast.error(error.response.data.message);
        }

    }


    return (
        <>
            <div className="flex justify-center h-[100vh] items-center">
                <form onSubmit={handleSubmit} className='space-y-3 border-1 border-gray-400 p-5 rounded-2xl w-[60vw] sm:w-[60vw] md:w-[40vw] lg:w-[30vw]'>
                    <Input type="date" label={"Date"} name='date' />
                    <Input type='number' label="Amount" name='amount' placeholder="Enter amount" />
                    <Select name='modeOfPayment' label="Mode of payment">
                        <SelectItem key="CASH">
                            CASH
                        </SelectItem>
                        <SelectItem key="UPI">
                            UPI
                        </SelectItem>
                        <SelectItem key="NEFT">
                            NEFT
                        </SelectItem>
                    </Select>
                    <Textarea label="Reason" name='reason' placeholder="Write a reason of your expenses" />
                    <div className='text-center'>
                        <Button type='submit' color='primary'>Submit</Button>
                    </div>
                </form>
            </div>
        </>
    );
}

export default AddExpense;